import { c as _c } from "react/compiler-runtime";
import type { Call } from "@signalwire/js";
import { useEffect, useRef } from "react";
export function useRemoteAudio(call) {
  const $ = _c(3);
  const audioRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== call) {
    t0 = () => {
      if (!call) {
        return;
      }
      const audio = new Audio();
      audio.autoplay = true;
      audioRef.current = audio;
      const sub = call.remoteStream$.subscribe(stream => {
        if (stream) {
          audio.srcObject = stream;
          audio.play().catch(_temp);
        }
      });
      return () => {
        sub.unsubscribe();
        audio.pause();
        audio.srcObject = null;
        audioRef.current = null;
      };
    };
    t1 = [call];
    $[0] = call;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}
function _temp(err) {
  console.error("[RemoteAudio] play() failed:", err);
}